export default "__VITE_ASSET__BWOqLVhg__"